/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View, TouchableOpacity } from "react-native";

import { Text, FadeInOutView } from "UpduoLibrary";

import { skaleRed, upduoLightestGray } from "config/UpduoColors";

interface DeactivateSettingsProps {
  setActiveModal: (activeModal: string) => void;
}
export default function DeactivateSettings({
  setActiveModal,
}: DeactivateSettingsProps) {
  return (
    <FadeInOutView>
      <TouchableOpacity
        onPress={() => {
          setActiveModal("deactivate");
        }}
      >
        <Text
          style={{
            color: skaleRed,
            fontSize: 16,
          }}
        >
          {"Leave Organization"}
        </Text>
      </TouchableOpacity>

      <View
        style={{
          borderColor: upduoLightestGray,
          borderWidth: 0.5,
          marginVertical: 20,
          width: "100%",
        }}
      ></View>
      <TouchableOpacity
        onPress={() => {
          setActiveModal("delete");
        }}
      >
        <Text
          style={{
            color: skaleRed,
            fontSize: 16,
          }}
        >
          {"Delete Account"}
        </Text>
      </TouchableOpacity>
    </FadeInOutView>
  );
}
